import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import confirmation from "../../assets/Confirmation.png";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";

export const ConfirmationModalPopUp = ({
  ChargeBeeSubscriptionFuc,
  Price,
  plan,
  Data,
  ...props
}) => {
  const ConfirmHandler = () => {
    ChargeBeeSubscriptionFuc(Data);
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>

      <Modal.Body className="text-center mb-5 deleteCardModal">
        <Image loading="lazy" src={confirmation} className="deleteImg" />
        <p>
          Are you sure you want to subscribe <b>{plan} Plan</b> ?
        </p>
        <div className="text-center small-btns d-flex">
          <Link onClick={props.onHide}>
            <p className="view">No</p>
          </Link>
          <Button
            variant="primary"
            className="green-btn mt-3"
            onClick={ConfirmHandler}
          >
            Pay ${Price ? Price : 0}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
